// mocked globally in setupTests.js

import { RESET_BUTTON_WIDTH_IN_PX } from '../components/buttons/ResetFieldButton';
import Constants from './Constants';

export const getCanvasContext = () => document.createElement('canvas').getContext('2d');

export const getTextWidth = (context, font, text) => {
    context.font = font;
    const metrics = context.measureText(text);
    return Math.ceil(metrics.width);
};

export const getInputMaxWidth = (node) => {
    const fieldComputedStyle = global.getComputedStyle(node.closest('.field'));
    const fieldPadding = Number.parseInt(fieldComputedStyle.paddingLeft, 10) + Number.parseInt(fieldComputedStyle.paddingRight, 10);
    const fieldMargin = Number.parseInt(fieldComputedStyle.marginLeft, 10) + Number.parseInt(fieldComputedStyle.marginRight, 10);
    return node.closest('.field-container').parentElement.clientWidth
        - fieldPadding
        - fieldMargin
        - Constants.DYNAMIC_WIDTH_GAP_IN_PX
        - RESET_BUTTON_WIDTH_IN_PX;
};

export const getSidePadding = (node) => {
    const styles = global.getComputedStyle(node);

    const paddingLeft = Number.parseFloat(styles.paddingLeft) || 0;
    const paddingRight = Number.parseFloat(styles.paddingRight) || 0;

    return paddingRight + paddingLeft;
};

export const getSideMargin = (node) => {
    const styles = global.getComputedStyle(node);

    const marginLeft = Number.parseFloat(styles.marginLeft) || 0;
    const marginRight = Number.parseFloat(styles.marginRight) || 0;

    return marginRight + marginLeft;
};

export const getInputMaxWidthWithoutLineBreak = (node) => {
    const fieldNode = node.closest('.field');
    const valueNode = node.closest('.field--value');
    let otherChildrenWidth = 0;

    // calculate sum of children's width excluding the valueNode which contains the 'node'
    for (let i = 0; i < fieldNode.children.length; ++i) {
        const child = fieldNode.children[i];
        if (child !== valueNode) {
            otherChildrenWidth += child.getBoundingClientRect().width + getSideMargin(child);
        }
    }

    return fieldNode.clientWidth
        - getSidePadding(fieldNode)
        - getSideMargin(valueNode)
        - otherChildrenWidth
        - Constants.DYNAMIC_WIDTH_GAP_IN_PX;
};

export const getTextFont = (node) => {
    const computedStyle = global.getComputedStyle(node);
    return `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
};
